import React, { Component } from "react";
import firebase from "../../utils/firebase";

import Button from "@atlaskit/button";
import EditorRemoveIcon from "@atlaskit/icon/glyph/editor/remove";

import "./profileFormReferenceCard.css";
export default class ProfileFormReferenceCard extends Component {
  handleDeleteClick = () =>
    firebase
      .firestore()
      .collection("my")
      .doc(this.props.userContext.user.uid)
      .update({
        [`references.${
          this.props.reference.referenceId
        }`]: firebase.firestore.FieldValue.delete()
      });

  render() {
    return (
      <div className="profile-reference-card profile-card">
        <h6 className="profile-reference-card__detail">
          {`Reference #${this.props.index}`}
        </h6>
        <p className="profile-reference-card__detail">
          {this.props.reference.name}
        </p>
        <p className="profile-reference-card__detail">
          {this.props.reference.address}
        </p>
        <p className="profile-reference-card__detail">
          {this.props.reference.telephone}
        </p>
        <p className="profile-reference-card__detail">
          {this.props.reference.acquaintanceLength}
        </p>
        <p className="profile-reference-card__detail">
          {this.props.reference.occupation}
        </p>

        <Button
          iconBefore={<EditorRemoveIcon />}
          onClick={this.handleDeleteClick}
        >
          Delete
        </Button>
      </div>
    );
  }
}

ProfileFormReferenceCard.defaultProps = {
  index: "",
  reference: {}
};



// WEBPACK FOOTER //
// ./src/components/profileFormReferenceCard/ProfileFormReferenceCard.js